export function savedPleadingPayload(versionId, versions, options) {
  if (!versions.some(v => v.id === versionId && v.status === 'approved')) {
    throw new Error('اختر قالبًا معتمدًا من المكتبة.');
  }
  const headerRow = Number(options.headerRow);
  if (!Number.isInteger(headerRow) || headerRow < 1 || headerRow > 100) {
    throw new Error('اختر صف عناوين Excel من 1 إلى 100.');
  }
  return {
    versionId,
    headerRow,
    sheetName: options.sheetName || '',
    defaults: {company: options.companyName || '', party: options.partyText || ''},
  };
}
